<template>
  <div class="login" layout="row" layout-align="center-center">
    <login-form></login-form>
    <div class="timeline">
      <div class="timeline-scroll">
        <widget id="atelu_info" tweet-limit="3"></widget>
      </div>
      <div class="timeline_note">ブラウザ版にログインしていると、タイムラインを表示できます。</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.login {
  height: 100vh;

  > div:first-child {
    margin-right: $spacing-unit * 2;
  }
}

.timeline_note {
  margin-top: 8px;
  font-size: 12px;
  text-align: center;
}

.timeline-scroll {
  width: $spacing-unit * 60;
  height: 510px;
  overflow-y: scroll;
  border-radius: 12px;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue'

import Widget from '@/client/components/_atoms/twitter_timeline_widget'
import LoginForm from '@/client/features/login/login_form'
export default defineComponent({
  components: {
    LoginForm,
    Widget
  }
})
</script>
